import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { WidgetDetailComponent } from './widget-detail/widget-detail.component';
import { WidgetListComponent } from './widget-list/widget-list.component';
import { MapEditorComponent } from './widget-detail/map-editor/map-editor.component';
import { WidgetDetailMainComponent } from './widget-detail/widget-detail-main/widget-detail-main.component';
import { WidgetDetailSunstudiesComponent } from './widget-detail/widget-detail-sunstudies/widget-detail-sunstudies.component';
import { WidgetDetailPreviewComponent } from './widget-detail/widget-detail-preview/widget-detail-preview.component';
import { WidgetDetailDashboardComponent } from './widget-detail/widget-detail-dashboard/widget-detail-dashboard.component';

export const widgetsRoutes: Routes = [
  {
    path: 'widgets',
    component: WidgetListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'widgets/:id',
    component: WidgetDetailComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: WidgetDetailDashboardComponent,
      },
      {
        path: 'maps',
        component: WidgetDetailMainComponent,
      },
      {
        path: 'preview',
        component: WidgetDetailPreviewComponent,
      },
      {
        path: 'sunstudies',
        component: WidgetDetailSunstudiesComponent,
      },
      {
        path: 'maps/map-editor/:mapId',
        component: MapEditorComponent,
        canActivate: [AuthGuard]
      }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(widgetsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class WidgetsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/widgets/widgets-routing.module.ts